module.exports = __webpack_public_path__ + "static/media/icon-piece5-7.033c1aca.png";